module.exports = __webpack_public_path__ + "img/023.bb843860.png";